/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { UnitDependencies } from './dependenciesUnitClass.generated.js';
import { createGravity } from '../../factoriesAny.js';
export var gravityDependencies = {
  BigNumberDependencies,
  UnitDependencies,
  createGravity
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesGravity.generated.js
// module id = 1374
// module chunks = 2